function hasSevereFoodAllergies(allergies) {
  return (
    (allergies || []).filter(
      allergy =>
        allergy.severe === true && allergy.food === true && allergy.name
    ).length > 0
  )
}

export { hasSevereFoodAllergies }
